import { SettingCoffeeShopSuggestiveInformationContainer } from "..";

export const SettingCoffeeShopSuggestiveMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingCoffeeShopSuggestiveInformationContainer />
    </div>
  );
};
